export * from './core-plugin-definitions';
export * from './global';
export * from './web-plugins';
export * from './web/index';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@capacitor/core/dist/esm/index.js
// module id = 643
// module chunks = 20